import { useTranslation } from 'react-i18next'

export const DefaultBehaviorFlags = () => {
  const { t } = useTranslation()

  const defaultFlags = [
    t('setup.behaviorDetection.flags.threats'),
    t('setup.behaviorDetection.flags.violence'),
    t('setup.behaviorDetection.flags.weapon'),
    t('setup.behaviorDetection.flags.harassment'),
    t('setup.behaviorDetection.flags.prejudice'),
    t('setup.behaviorDetection.flags.disparaging'),
    t('setup.behaviorDetection.flags.selfHarm'),
    t('setup.behaviorDetection.flags.suggestiveContent'),
    t('setup.behaviorDetection.flags.fraud'),
    t('setup.behaviorDetection.flags.profanity'),
    t('setup.behaviorDetection.flags.polarizingContent'),
    t('setup.behaviorDetection.flags.drugs'),
    t('setup.behaviorDetection.flags.nudity'),
    t('setup.behaviorDetection.flags.alcohol'),
  ]

  return (
    <div className="flex flex-wrap gap-4">
      {defaultFlags.map((flag, index) => (
        <div
          key={index}
          className="px-6 py-3 max-md:px-4 max-md:py-2 bg-baseColorHighlight rounded-full text-base font-medium text-neutralColor border border-neutralColor30"
        >
          {flag}
        </div>
      ))}
    </div>
  )
}
